import React, { Component } from 'react';
import max from 'date-fns/max';
import min from 'date-fns/min';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import isEqual from 'date-fns/is_equal';
import moment from 'moment';
import _ from 'lodash';
import { TextField, MenuItem, Dialog, createTheme, MuiThemeProvider } from '@material-ui/core';
import 'react-infinite-calendar/styles.css';
import { func, bool, instanceOf, number, shape, string, objectOf } from 'prop-types';
import images from '../../../resources/images';
import cx from 'classnames';

import { campaignRangeToString, convertTimezoneDate } from '../../helpers/formatData';
import constTypeOfToast, { TRACKING_SOURCE_NAME, VISUAL_STATUS, CONNECTION_NAME } from '../../helpers/constant';
import { advertiserShape } from '../../helpers/propTypes';
import checkDataAvailable from '../InfiniteCalendar/utils/checkDataAvailable';
import { dateToString } from '../../helpers/formatData';
import styles from './styles.scss';
import constants, { ADVERTISER_WO_CAMPAIGN_RANGE } from './constants';
import { EVENT_TYPE } from '../InfiniteCalendar/Calendar/withRange';
import InfiniteCalendar, {
    Calendar,
    withRange
} from '../InfiniteCalendar';
import { getMegaphoneColor } from '../../helpers/common';

const {
    CUSTOM_VALUE,
    DATE_RANGE_LIST_DEFAULT,
    NONVALUE_DATERANGE
} = constants;

const RangedCalendar = withRange(Calendar);

export const customSelectStyle = createTheme({
    overrides: {
        MuiMenuItem: {
            root: {
                paddingTop: 11,
                paddingBottom: 11
            }
        },
        MuiListItem: {
            root: {
                '&$selected': {
                    backgroundColor: 'rgba(0, 0, 0, 0.14)'
                },
                '&$selected:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.14)'
                }
            },
            button: {
                '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.08)'
                }
            }
        },
    }
})

export default class DatePicker extends Component {

    static defaultProps = {
        value: CUSTOM_VALUE,
        campaign: {},
        tooltipOutOfRangeText: "This date is outside of the available data range and may skew results",
        showToast: () => {},
        isShowCalendarIcon: true,
        changeDateRange: () => {},
        fullWidth: true,
    };

    static propTypes = {
        dateRangeList: objectOf(shape({
            value: number,
            label: string
        })),
        dateRangeLimitInDays: number,
        tooltipOutOfRangeText: string,
        isCustom: bool,
        isShowCalendarIcon: bool,
        useWatchlistsAsAdSource: bool,
        fullWidth: bool,
    };

    state = {
        displayPicker: false,
        tooltipData: {
            top: 0,
            left: 0,
            width: 0,
            widthDay: 0,
            date: '',
            showTooltip: false
        },
        pickerRangeSelected: this.initialSelected,
        initialSelected: this.initialSelected,
        disableApply: true
    };

    componentDidMount() {
        const { isShowDataCollected = true, inCampaignTab, campaign, advertiser, changeDateRange, defaultValue, dateRangeList, typePicker } = this.props;
        const {campaign_id: campaignId } = campaign;
        if (campaignId) {
            // defaultValue and dateRangeList should go together in props to make sure of updating initial range with default value on redux
            if (defaultValue && dateRangeList && typePicker && !campaign[typePicker.name]) {
                const rangeObj = dateRangeList[defaultValue];
                const selectedDefault = _.pick(rangeObj, ['start', 'end']);
                changeDateRange(campaignId, selectedDefault, typePicker.name, defaultValue);
            
            // updating initial range without default value
            } else if (isShowDataCollected && !campaign.masterCalendar && !inCampaignTab && advertiser.data_collected_last !== undefined) {
                changeDateRange(campaignId, this.initialSelected , 'masterCalendar', CUSTOM_VALUE);
            }
        }
    }

    /*
     *  Temporary, we need to set some init function both in did mount and did update:
     *  Did mount for cases that all initial data have set before and will not cause update after mount (change tab for example)
     *  Did update for cases that can't get enough data after mounting.
     */

    componentDidUpdate = (prevProps, prevState) => {
        const {
            campaign,
            isShowDataCollected = true,
            inCampaignTab = false,
            advertiser,
            changeDateRange,
            dateRangeList,
            defaultValue,
            typePicker
        } = this.props;
        const { initialSelected, pickerRangeSelected } = this.state;
        const { pickerRangeSelected: prevPickerRangeSelected} = prevState;
        const {campaign_id: campaignId } = campaign;
        if (campaignId) {
            // defaultValue and dateRangeList should go together in props to make sure of updating initial range with default value on redux
            if (defaultValue && dateRangeList && typePicker && !campaign[typePicker.name]) {
                const rangeObj = dateRangeList[defaultValue];
                const selectedDefault = _.pick(rangeObj, ['start', 'end']);
                changeDateRange(campaignId, selectedDefault, typePicker.name, defaultValue);
            
            // updating initial range without default value
            } else if (isShowDataCollected && !campaign.masterCalendar && !inCampaignTab && advertiser.data_collected_last !== undefined) {
                changeDateRange(campaignId, this.initialSelected , 'masterCalendar', CUSTOM_VALUE);
            }
        }
        const stateInitialSelectedConverted = {
            start: dateToString(_.get(initialSelected, 'start')),
            end: dateToString(_.get(initialSelected, 'end'))
        }
        const initialSelectedConverted = {
            start: dateToString(_.get(this.initialSelected, 'start')),
            end: dateToString(_.get(this.initialSelected, 'end'))
        }
        if (!_.isEqual(stateInitialSelectedConverted, initialSelectedConverted)) {
            this.setState({
                initialSelected: this.initialSelected,
                pickerRangeSelected: this.initialSelected
            })
        }
    }

    get initialSelected() {
        const { inCampaignTab, selected, campaign, selectedTimezone } = this.props;
        const range = {
            start: _.get(selected, 'start', moment.tz(selectedTimezone).format()),
            end: _.get(selected, 'end', moment.tz(selectedTimezone).format())
        }
        if (!inCampaignTab && campaign && campaign.campaign_id > 0 &&
            campaign.start_date && campaign.end_date && !campaign.masterCalendar) {
            return {
                start: campaign.start_date,
                end: campaign.end_date
            }
        }
        if (!inCampaignTab && !selected && campaign && campaign.campaign_id < 1) {
            return ADVERTISER_WO_CAMPAIGN_RANGE;
        }
        return range;
    }

    get dataCollected() {
        const { advertiser, isShowDataCollected = true, campaign } = this.props;
        if(!isShowDataCollected || !campaign) {
            return {}
        }
        const {
            data_collected_start,
            data_collected_last,
            trackingDataSourceName
        } = advertiser
        const {
            liveread_avaiable_start,
            liveread_avaiable_last,
            spot_avaiable_start,
            spot_avaiable_last,
            watchlist_avaiable_start,
            watchlist_avaiable_last
        } = campaign;
        const dataCollectedObj = {
            'livereadAvailable': {
                'name': 'Live Reads Available',
                'startDate': this.formatToLocalDate(liveread_avaiable_start),
                'endDate': this.formatToLocalDate(liveread_avaiable_last)
            },
            'spotDataAvailable': {
                'name': 'Spot Data Available',
                'startDate': this.formatToLocalDate(spot_avaiable_start),
                'endDate': this.formatToLocalDate(spot_avaiable_last)
            },
            'watchlistAvailable': {
                'name': 'Watchlist Available',
                'startDate': this.formatToLocalDate(watchlist_avaiable_start),
                'endDate': this.formatToLocalDate(watchlist_avaiable_last)
            },
        }

        dataCollectedObj.sourceData = {
            'name': CONNECTION_NAME[trackingDataSourceName] || '',
            'startDate': this.formatToLocalDate(data_collected_start),
            'endDate': this.formatToLocalDate(data_collected_last)
        }
        return dataCollectedObj;
    }

    getTooltipPosition = (showTooltip, top, left, widthDay, width) => {
        return {
            display: showTooltip ? "block" : "none",
            top: `${top + 65}px`,
            left: `${left + widthDay / 2 - width}px`
        };
    };

    handleClose = () => {
        const { tooltipData } = this.state;
        this.setState({
            displayPicker: false,
            tooltipData: {
                ...tooltipData,
                showTooltip: false
            }
        });
    };

    openPicker = () => {
        this.setState({ displayPicker: true });
    };

    formatToLocalDate = (utcTime) => {
        return utcTime ? format(utcTime, 'YYYY-MM-DD') : 'N/A';
    };

    onChangePicker = (pickerRangeSelected) => {
        const { campaign } = this.props;
        const isAvailableDateRange = this.checkDataAvailable(campaign);
        this.setState({
            pickerRangeSelected,
            disableApply: !isAvailableDateRange,
        });
    }

    onApplyPicker = () => {
        const { start, end } = this.state.pickerRangeSelected;
        const {
            campaign,
            inCampaignTab,
            changeDateRange,
            typePicker,
            isShowDataCollected = true,
            setEditingCondition,
            onChange,
          selectedTimezone
        } = this.props;
        const convertedStartDate = convertTimezoneDate(start, selectedTimezone, true);
        const convertedEndDate = convertTimezoneDate(end, selectedTimezone);
        if (inCampaignTab) {
            campaign && changeDateRange(campaign.campaign_id, { start: convertedStartDate, end: convertedEndDate } , 'campaignCalendar', -1, true)
            setEditingCondition();
        }
        onChange && onChange({ start: convertedStartDate, end: convertedEndDate });
        campaign && !inCampaignTab && changeDateRange(campaign.campaign_id, { start: convertedStartDate, end: convertedEndDate }, typePicker.name, -1)
        if (isShowDataCollected && !inCampaignTab) {
            changeDateRange(campaign.campaign_id, { start, end: convertedEndDate }, typePicker.name, CUSTOM_VALUE);
            const isHaveData = this.checkDataAvailableRange(start, end);
            if (!isHaveData) {
                const messageToast = <span>The dates selected are outside of the <br/>data range and may skew results. <br/>Revisit the calendar for dates with data.</span>
                this.props.showToast({
                    message: messageToast,
                    action: 'Dismiss',
                    type: constTypeOfToast.WARNING
                });
            }
        }

        this.setState({
            displayPicker: false,
            initialSelected: {
                start: convertedStartDate,
                end: convertedEndDate
            }
        });
        this.closePicker();
    }

    checkDataAvailableRange = (start, end) => {
        const {
            sourceData = {},
            livereadAvailable,
            watchlistAvailable,
            spotDataAvailable,
        } = this.dataCollected;
        const startDate = moment(start);
        const endDate = moment(end);
        return spotDataAvailable.startDate !== 'N/A' && this.checkDate(startDate, endDate, spotDataAvailable)
          || livereadAvailable.startDate !== 'N/A' && this.checkDate(startDate, endDate, livereadAvailable)
          || watchlistAvailable.startDate !== 'N/A' && this.checkDate(startDate, endDate, watchlistAvailable)
          || sourceData.startDate !== 'N/A' && this.checkDate(startDate, endDate, sourceData)
    }

    onCancelPicker = () => {
        this.setState(state => ({
            pickerRangeSelected: state.initialSelected
        }));
        this.setDisableApply(true);
        this.closePicker();
    }

    closePicker = () => {
        this.setState({displayPicker: false})
    }

    handleChangeStartBound = (date) => {
        this.setState(state => {
            const { campaign } = this.props;
            const end = _.get(state, 'pickerRangeSelected.end', new Date());
            const isAvailableDateRange = this.checkDate(moment(date), moment(end), campaign);
            return {
                pickerRangeSelected: {
                    start: date,
                    end,
                    eventType: EVENT_TYPE.END
                },
                disableApply: !isAvailableDateRange,
            }
        });
      }
    
    handleChangeEndBound = (date) => {
        this.setState(state => {
            const { campaign } = this.props;
            const start = _.get(state, 'pickerRangeSelected.start', new Date());
            const isAvailableDateRange = this.checkDate(moment(start), moment(date), campaign);
            return {
                pickerRangeSelected: {
                end: date,
                start,
                eventType: EVENT_TYPE.END
                },
                disableApply: !isAvailableDateRange,
            }
        });
    }

    handleBoundError = (isError) => {
        const { isCustom } = this.props;
        if(isCustom) {
            isError && this.setDisableApply(true);
        } else {
            // keep current logic, not sure about it
            const { pickerRangeSelected } = this.state;
            const { eventType } = pickerRangeSelected;
            if (isError || eventType === EVENT_TYPE.END) {
                this.setDisableApply(isError);
            }
        }
    }

    setDisableApply = (value) => {
        this.setState({disableApply: value})
    }

    onExit = () => {
        this.setDisableApply(true);
    }

    checkDate = (startDate, endDate, data) => {
        const startDateData = moment(data.startDate);
        const endDateData = moment(data.endDate);
        return startDate.diff(startDateData) >= 0 && endDate.diff(endDateData) <= 0;
    };

    onSelect = (event) => {
        const {
            campaign,
            changeDateRange,
            typePicker,
            inCampaignTab,
            selectDateRange,
            dateRangeList,
            onChange
        } = this.props;
        const { value } = event.target;
        const rangeList = dateRangeList ? dateRangeList : DATE_RANGE_LIST_DEFAULT;
        if (!rangeList[value]) {
            this.openPicker();
        } else {
            const range = {
                start: rangeList[value].start,
                end: rangeList[value].end
            }
            onChange && onChange(range, value);
            if(inCampaignTab) {
                campaign && changeDateRange(campaign.campaign_id, range , 'campaignCalendar', value, true);
                selectDateRange();
            }
            else {
                campaign && changeDateRange(campaign.campaign_id, range, typePicker.name, value);
            }
            this.setState({
                initialSelected: range,
                pickerRangeSelected: range
            })
        }
    }

    getEarliestDate = (sportDate, liveReadDate, googleAnalyticData) => {
        let listDate = [sportDate, liveReadDate, googleAnalyticData];
        listDate = (listDate.filter(date => date !== 'N/A')).map(date => parse(date));
        if (listDate.length === 0) {
            return null;
        }
        return min(...listDate);
    };

    getLatestDate = (sportDate, liveReadDate, googleAnalyticData) => {
        let listDate = [sportDate, liveReadDate, googleAnalyticData];
        listDate = (listDate.filter(date => date !== 'N/A')).map(date => parse(date));
        if (listDate.length === 0) {
            return null;
        }
        return max(...listDate);
    };

    showTooltip = (day, status) => {
        const widthSpan = this.dayTooltip;
        const { tooltipData } = this.state;
        const { width } = tooltipData;
        this.setState({
            tooltipData: {
                ...tooltipData,
                ...day,
                width: widthSpan ? widthSpan.offsetWidth / 2 : width,
                showTooltip: status
            }
        });
    };

    refDayTooltip = (node) => {
        this.dayTooltip = node;
    };

    checkDataAvailable(data) {
        if (data.startDate === 'N/A') {
        return false;
        }
        const startDate = parse(data.startDate);
        const endDate = parse(data.endDate);
        const currentDate = parse(this.state.tooltipData.date);
        return !!((isAfter(currentDate, startDate) || isEqual(currentDate, startDate)) && (isBefore(currentDate, endDate) || isEqual(currentDate, endDate)));
    }

    gettooltipData = (dayDetail) => {
        const date = _.get(this.state, 'tooltipData.date', new Date());
        const currentDate = format(parse(date), 'MMM Do, YYYY');
        const tooltipWithData =
            <div className={styles.tooltipData}>
                <div className={styles.dayTitle}>
                    {currentDate}
                </div>
                <div className={styles["title-divide"]}/>
                {dayDetail.isSpotAvailable &&
                <div className={styles.spotAvailableText}>
                    Spot Data Available
                </div>
                }
                {dayDetail.isLiveReadAvailable &&
                <div className={styles.liveReadAvailableText}>
                    Live Reads Data Available
                </div>
                }
                {dayDetail.isWatchlistAvailable &&
                <div className={styles.watchlistAvailableText}>
                    Watchlist Available
                </div>
                }
            </div>;
        const { tooltipOutOfRangeText } = this.props;
        const tooltipWithoutData =
            <div style={{
                fontSize: "12px",
                margin: "5px 0px",
                textAlign: "left",
                width: "200px"
            }}>
                {tooltipOutOfRangeText}
            </div>;
        
        const noData = !dayDetail.isSpotAvailable && !dayDetail.isLiveReadAvailable && !dayDetail.isWatchlistAvailable;

        return noData ? tooltipWithoutData : tooltipWithData;
    };


    clickFirst = () => {
        if (!this.props.customSelect) {
            this.openPicker();
        }
    };

    drawConnectionIcon = () => {
        const connectedStyleIcon = getMegaphoneColor(this.props.advertiser);
        return <span
            className={cx(
                'icon-attribution-app',
                styles[connectedStyleIcon],
                styles.advertiserIcon
            )}
        />
    }

    render() {
        const { tooltipData, displayPicker, initialSelected, pickerRangeSelected, disableApply } = this.state;
        const {
            disabled,
            isShowDataCollected,
            campaign,
            iconClassName,
            dateRangeList,
            value,
            dateRangeLimitInDays,
            useWatchlistsAsAdSource,
            isShowCalendarIcon,
            fullWidth,
          } = this.props;
        let { top, left, showTooltip, widthDay, width, date } = tooltipData;

        const rangeList = dateRangeList ? dateRangeList : DATE_RANGE_LIST_DEFAULT
        const adsTypeDate = _.get(campaign, 'adsTypeDate', {});
        const rangeString = value === 0 ? NONVALUE_DATERANGE.label: campaignRangeToString(initialSelected);
        const listRange = Object.values(rangeList);

        let dayDetail, earliestDateHaveData, latestDateHaveData;
        const dataCollected = this.dataCollected;
        if (isShowDataCollected && campaign) {
            const {
                sourceData = {},
                livereadAvailable,
                watchlistAvailable,
                spotDataAvailable,
            } = dataCollected;
            dayDetail = checkDataAvailable(date, adsTypeDate);
            earliestDateHaveData = this.getEarliestDate(
                spotDataAvailable.startDate,
                livereadAvailable.startDate,
                sourceData.startDate,
                watchlistAvailable.startDate
            );
            latestDateHaveData = this.getLatestDate(spotDataAvailable.endDate, livereadAvailable.endDate, sourceData.endDate, watchlistAvailable.endDate);
        }
       
        return (
            <div className={cx(styles["range--wrapper"])}>
                <Dialog
                    open={displayPicker}
                    onClose={this.handleClose}
                    onExit={this.onExit}
                    onBackdropClick={this.onCancelPicker}
                >
                    <InfiniteCalendar
                        Component={RangedCalendar}
                        displayOptions={{showHeader: false}}
                        showTooltip={this.showTooltip}
                        selected={pickerRangeSelected}
                        minDate={earliestDateHaveData}
                        maxDate={latestDateHaveData}
                        locale={{
                            headerFormat: "MMM Do"
                        }}
                        height={300}
                        onSelect={this.onChangePicker}
                        calendarData={{
                            data: dataCollected,
                            icon: this.drawConnectionIcon()
                        }}
                        isShowDataCollected={isShowDataCollected}
                        onApplyPicker={this.onApplyPicker}
                        onCancelPicker={this.onCancelPicker}
                        adsTypeDate={adsTypeDate}
                        disableApply={disableApply}
                        dateRangeLimitInDays={dateRangeLimitInDays}
                        onChangeStartBound={this.handleChangeStartBound}
                        onChangeEndBound={this.handleChangeEndBound}
                        onBoundError={this.handleBoundError}
                        useWatchlistsAsAdSource={useWatchlistsAsAdSource}
                    />
                </Dialog>
                {showTooltip && displayPicker && isShowDataCollected &&
                <span className={styles.tooltipText}
                      style={this.getTooltipPosition(showTooltip, top, left, widthDay, width)} ref={this.refDayTooltip}>
                        {this.gettooltipData(dayDetail)}
                    </span>
                }
                {this.props.customSelect ?
                    <MuiThemeProvider theme={customSelectStyle}>
                        <TextField
                            data-test="modifyCalendar"
                            select
                            value={value}
                            onChange={this.onSelect}
                            className={cx({[styles.dateRange]: fullWidth})}
                            SelectProps={{
                                renderValue: () => (rangeList[value] ? rangeList[value].label : rangeString),
                                classes: {
                                    select: styles.customDateRange
                                }
                            }}
                            data-veritone-element="modify-calendar"
                            disabled={!campaign || disabled}
                            InputProps={{ disableUnderline: true }}
                        >
                            <div
                                className={cx(styles["disable-click"])}
                            >
                                <div data-test="modifyCalendarTitle" className={cx(styles["range-title"])}>
                                    {rangeList[value] ? rangeList[value].label : "Custom"}
                                </div>
                                <div data-test="modifyCalendarRange" className={cx(styles["range-value"])}>
                                    {rangeString}
                                </div>
                                <hr className={cx(styles["custom-hr"])}/>
                            </div>
                            {
                                listRange.map(({ value, label }) => {
                                    return (
                                        <MenuItem key={value} value={value}
                                                data-veritone-element={`menu-date-range-${value}`}>
                                            {value === CUSTOM_VALUE && <hr/>}
                                            {label}
                                        </MenuItem>
                                    );
                                })
                            }
                            <hr/>
                            <MenuItem
                                key={CUSTOM_VALUE}
                                value={CUSTOM_VALUE}
                                data-veritone-element="menu-date-range-custom"
                                onClick={!disabled ? this.openPicker : null}
                            >
                                Custom...
                            </MenuItem>

                        </TextField>
                    </MuiThemeProvider>
                    :
                    <TextField
                        data-test="disableModifyCalendar"
                        disabled={disabled}
                        value={rangeString}
                        onClick={!disabled ? this.clickFirst : null}
                        className={this.props.inCampaignTab && cx(styles["date-range-field"])}
                    />}
                    {isShowCalendarIcon && (
                        <div
                            className={cx(styles['range--button'])}
                            onClick={!disabled ? this.openPicker : null}
                            data-veritone-element="button-calendar"
                        >
                            <img
                                src={images.newCalendarIcon}
                                className={cx(iconClassName, styles.calendarIcon)}
                            />
                        </div>
                    )}
            </div>
        );
    }
}

DatePicker.propTypes = {
    onChange: func.isRequired,
    showToast: func,
    selected: shape({
        end: instanceOf(Date),
        start: instanceOf(Date)
    }),
    advertiser: advertiserShape,
    changeDateRange: func,
    typePicker: instanceOf(Object),
    customSelect: bool,
    value: number,
    disabled: bool,
    isShowDataCollected: bool,
    inCampaignTab: bool,
    setEditingCondition: func,
    campaign: instanceOf(Object),
    selectDateRange: func,
    iconClassName: string,
    defaultValue: number,
    selectedTimezone: string
};
